import { connectHits } from 'instantsearch.js/es/connectors';

// create the render function
const renderHits = (renderOptions) => {
    const { hits, widgetParams } = renderOptions;

    widgetParams.container.innerHTML = `
        ${hits.map((item) => `
            <a
                href="${item.url}"
                class="grid sm:block grid-cols-[45%_1fr] pb-5 sm:pb-0 mb-5 sm:mb-0 border-b-2 last:border-b-0 sm:border-b-0 group/card">
                ${item.image ? `
                    <div class="relative sm:mb-4 overflow-hidden after:block after:pb-[100%]${item.post_type === 'product' ? ' bg-[#fab991]' : ''}">
                        <img
                            src="${item.image}"
                            class="absolute w-full h-full ${item.post_type === 'product' ? 'p-8 object-contain' : 'object-cover'} transition-transform group-hover/card:scale-105"
                            alt="${item.image_alt}">
                        ${item.taxonomies && item.taxonomies.category.length > 0 ? `
                            <span class="absolute bottom-0 py-3.5 px-5 bg-orange text-xs font-semibold tracking-wider uppercase whitespace-nowrap">${item.taxonomies.category[0]}</span>
                        ` : ''}
                    </div>
                ` : ''}
                <div class="flex sm:block flex-col justify-center pl-5 sm:pl-0">
                    <h2 class="mb-4 text-2xl">${item.title}</h2>
                    <span class="flex items-center text-orange font-gotham text-xs font-bold tracking-widest uppercase transition-colors hover:text-black group/text-btn " role="button" tabindex="0">
                    View</span>
                </div>
            </a>
        `).join('')}
    `;
};

// create the custom widget
const customHits = connectHits(renderHits);

export default customHits;
